@if (isLoadingFields) {
  <app-loader></app-loader>
}
@if (!isLoadingFields) {
  <ng-container [formGroup]="form">
    <div formArrayName="rules" class="full-width">
      @for (field of rules; track field; let j = $index) {
        <div [formGroupName]="j" class="rulesGroup">
          <ng-container>
            <app-autocomplete class="field padding-horizontal-4" [itemsList]="maFieldsAutocomplete"
              [label]="'Select a Field' | translate" [required]="true" formControlName="field">
            </app-autocomplete>
            <mat-form-field class="field_comparison_operator margin-horizontal-10" floatLabel="always"
              [hideRequiredMarker]="true">
              <mat-label></mat-label>
              <mat-select matNativeControl formControlName="operator"
                (selectionChange)="resetLineOnChange($event.value, field)">
                @for (operator of maFieldsOperators; track operator) {
                  <mat-option [value]="operator.name">
                    {{operator.label}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="field_value">
              @if (getMaRuleInputType(field.get('operator').value) === MaFieldType.Array) {
                <mat-form-field class="full-width">
                  <mat-label>add a value</mat-label>
                  <mat-chip-grid #value aria-label="Field Value">
                    @for (value of field.get('value').value; track value) {
                      <mat-chip-row (removed)="maValueRemove(field, value)">
                        {{value}}
                        <button matChipRemove> <mat-icon>cancel</mat-icon> </button>
                      </mat-chip-row>
                    }
                    <input [matChipInputFor]="value" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="maValueAdd(field, $event)">
                    </mat-chip-grid>
                  </mat-form-field>
                  @if (field.get('value').invalid && (field.get('value').dirty || field.get('value').touched)) {
                    <div
                      class="error rule-error">
                      @if (field.get('value').errors.required) {
                        <div translate>
                          At least 1 value need to be added
                        </div>
                      }
                    </div>
                  }
                }
                @if (getMaRuleInputType(field.get('operator').value) === MaFieldType.Numeric) {
                  <mat-form-field class="full-width input-numeric"
                    >
                    <mat-label>set a value</mat-label>
                    <input matInput formControlName="value">
                    @if (field.get('value').hasError('required')) {
                      <mat-error>The field is required.</mat-error>
                    }
                    @if (field.get('value').hasError('number')) {
                      <mat-error>The field must contain only digits.</mat-error>
                    }
                  </mat-form-field>
                }
              </div>
            </ng-container>
            <div class="action-icons">
              @if (j>0) {
                <mat-icon matTooltip="{{'Delete' | translate}}" (click)="removeRuleLine(j)"
                class="margin-horizontal-4">remove</mat-icon>
              }
              @if (j===rules.length-1) {
                <mat-icon matTooltip="{{'Add' | translate}}" (click)="addRuleLine()"
                class="margin-horizontal-4">add_circle</mat-icon>
              }
            </div>
          </div>
        }
      </div>
    </ng-container>
  }